import React from "react";
import { withStyles } from "@material-ui/core";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "../../../../../common/StyledToolTip";
import SearchBox from "../../../../../common/SearchBox";
import ClearAllFilterButton from "../../../../../dataGrid/columnFilters/ClearAllFilterButton";
const styles = (theme) => ({
  headerStyle: {
    margin: "5px 0px",
    height: "30px",
    borderRadius: "4px 4px 0 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: "14px",
    fontWeight: 600,
  },
  headerIconStyles: {
    padding: "5px 10px",
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor,
  },
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  enableIcon: {
    cursor: "pointer",
  },
  iconLayout: {
    color: theme.iconColor,
    "&>span": {
      padding: "10px 10px",
      color: theme.iconColor,
    },
  },
  gridActionIcons: {
    "& $actionIcon": {
      paddingLeft: 10,
      "&:not(:last-child)": {
        borderRight: `1px solid ${theme.AppBGColor}`,
        paddingRight: 10,
      },
    },
  },
});

const TerminalOnboardGridHeader = ({
  classes,
  isTerminalFormOpen,
  gridApi,
  selectedTerminals,
  onBoardTerminalFormOpen,
  updateQuickFilterText,
}) => {
  const getIconTitle = (params) => {
    const { iconName, isTerminalFormOpen, disableEditIcon, disableAddIcon } =
      params;
    if (isTerminalFormOpen) {
      return "Add/update in progress";
    }
    switch (iconName) {
      case "editIcon":
        if (!disableEditIcon) {
          return "Click to edit";
        } else {
          return "Select a row to edit";
        }
      case "addIcon":
        return disableAddIcon ? "Disabled" : "Click to add";
      default:
        return "";
    }
  };

  const disableAddIcon = isTerminalFormOpen;
  const disableEditIcon = !selectedTerminals?.length || isTerminalFormOpen;
  const params = {
    isTerminalFormOpen,
    disableEditIcon,
    disableAddIcon,
  };
  return (
    <div className={classes.headerStyle}>
      <div>
        <span
          className={classes.headerLabel}
          data-automationid="TerminalOnboarding-title"
        >
          Terminal Onboarding
        </span>
      </div>
      <div>
        <span className={classes.gridActionIcons}>
          <SearchBox onChange={updateQuickFilterText} />
          <ClearAllFilterButton gridApi={gridApi} />
        </span>
        <span
          className={`${classes.headerIconStyles} ${classes.iconLayout} ${
            disableEditIcon ? classes.disableIcon : classes.enableIcon
          }`}
          onClick={() => {
            !disableEditIcon
              ? onBoardTerminalFormOpen(selectedTerminals, selectedTerminals[0])
              : null;
          }}
        >
          <Tooltip title={getIconTitle({ iconName: "editIcon", ...params })}>
            <EditIcon />
          </Tooltip>
        </span>
        <span
          className={`${classes.headerIconStyles} ${classes.iconLayout}  ${
            disableAddIcon ? classes.disableIcon : classes.enableIcon
          }`}
          onClick={() => {
            !disableAddIcon ? onBoardTerminalFormOpen([], null) : null;
          }}
        >
          <Tooltip title={getIconTitle({ iconName: "addIcon", ...params })}>
            <AddRoundedIcon />
          </Tooltip>
        </span>
      </div>
    </div>
  );
};
export default withStyles(styles)(TerminalOnboardGridHeader);
